import React from "react";
import { EntryRow } from "./EntryRow.js";
import { MonthEntries } from "../../../model/accounting/entry/Entry.js";

type Props = {
  month: MonthEntries;
};

/**
 * Renders rows corresponding to month in the entries table.
 */
export const MonthRows = ({ month }: Props) => {
  return (
    <>
      <tr>
        <th colSpan={10}>{month.monthName}</th>
      </tr>
      {month.entries.map((entry) => (
        <EntryRow key={entry.id} entry={entry} />
      ))}
    </>
  );
};
